<script>
  const currentYear = new Date().getFullYear();
</script>

<footer>
  <a
    href="https://www.frederickroman.com/"
    target="_blank"
    rel="noopener"
    class="link"
  >
    &copy; Frederick Roman {currentYear}
  </a>
</footer>

<style>
  footer {
    text-align: center;
    padding: 20px;
  }
  .link {
    color: #c4b1b1;
    text-decoration: none;
  }
</style>
